// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__17e9O","info":"PatientInfo_info__T6BIm"};